import React, { createContext, useMemo } from 'react';
import { useCalcCSSPosition } from "../hooks/useCalcCSSPosition.js";
import { useCalcLabelOffset } from "../hooks/useCalcLabelOffset.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const SliderContext = /*#__PURE__*/createContext({
  calcCSSPosition: () => '0',
  calcLabelOffset: () => 0
});
export function SliderProvider({
  children,
  minValue,
  maxRange,
  trackEle
}) {
  const calcCSSPosition = useCalcCSSPosition(minValue, maxRange);
  const calcLabelOffset = useCalcLabelOffset(minValue, maxRange, trackEle);
  return /*#__PURE__*/_jsx(SliderContext.Provider, {
    value: useMemo(() => ({
      calcCSSPosition,
      calcLabelOffset
    }), [calcCSSPosition, calcLabelOffset]),
    children: children
  });
}